import { isValid, isPast, formatISO, format } from 'date-fns';
import { dateUs2Iso } from "../../global/dateUtils";
import { validateEmail} from "../../global/utils";

export const getOptionTemplateName = (court, balances) => {
    const bals = balances.filter(b => b.trafficSchoolType);
    if (bals && bals.length > 0 && court.trafficSchoolConfigs && court.trafficSchoolConfigs.length > 0) {
        const bal = bals[0];
        const configs = court.trafficSchoolConfigs.filter(cfg => cfg.optionType === bal.trafficSchoolType && cfg.formTemplate);
        if (configs && configs.length > 0) return configs[0].formTemplate;
    }
    return null;
}

export const getOptionCompletionText = (balances) => {
    const trafficSchoolBalance = balances.find(b => b.trafficSchoolId && b.trafficSchoolType);
    return trafficSchoolBalance ? trafficSchoolBalance.optionCompletionText : null;
};

export const validateEpRequest = (form, phone) => {
    let errors = '';
    if (!form.defendantName) {
        errors = "The defendant's name is required";
    } else if (form.defendantName.length < 5) errors = "The defendant's name must be at least 5 characters long";
    if (!form.caseNumber) errors += `${errors.length > 0 ? '; ' : ''}The case number is required`;
    if (!form.address || form.address.length < 10) errors += `${errors.length > 0 ? '; ' : ''}The address is required and must be at least 10 characters long`;
    if (!form.city) errors += `${errors.length > 0 ? '; ' : ''}The city is required`;
    if (!form.state) errors += `${errors.length > 0 ? '; ' : ''}The state is required`;
    if (!form.zip || form.zip.length < 5)errors += `${errors.length > 0 ? '; ' : ''}The zip code is required and must be five characters long`;
    if (!form.email) {
        errors += `${errors.length > 0 ? '; ' : ''}The email address is required`;
    } else if (!validateEmail(form.email)) errors += `${errors.length > 0 ? '; ' : ''}The email address is invalid`;
    if (!phone) errors += `${errors.length > 0 ? '; ' : ''}The phone number is required, and must include 10 digits within the format mask`;
    if (!form.license) errors += `${errors.length > 0 ? '; ' : ''}The driver license number is required`;
    if (!form.expires) {
        errors += `${errors.length > 0 ? '; ' : ''}The license expiration date is required`;
    } else {
        const testDate = dateUs2Iso(form.expires);
        if (!testDate) errors += `${errors.length > 0 ? '; ' : ''}The license expiration date is invalid`;
    }
    if (!form.plea) errors += `${errors.length > 0 ? '; ' : ''}You must select a plea to enter`;
    return errors;
}

export const getEpRequest = (form, balance) => {
    return {
        optionTemplate: 'epPlea',
        optionType: balance.trafficSchoolType,
        defendantName: form.defendantName,
        caseNumber: form.caseNumber,
        address: form.address,
        city: form.city,
        state: form.state,
        zip: form.zip,
        email: form.email,
        phone: form.phone,
        license: form.license,
        expires: form.expires ? dateUs2Iso(form.expires) : null,
        plea: form.plea
    }
}

export const isOnline = (description) => {
    if (description) {
        const lower = description.toLowerCase();
        if (lower.includes('online') || lower.includes('internet') || lower.includes('web') || lower.includes('remote')) return true;
    }
    return false;
}

export const validateRockVyRequest = (form, phone, radios, dob, violationDate) => {
    let errors = '';
    if (!radios.priorSupervision) {
        errors = 'You must indicate whether you have had supervision for a traffic ticket that was issued within the last 12 months';
    } else if (radios.priorSupervision === 'Yes') {
        errors = 'You are not eligible for traffic school at this time, because you have had supervision for a traffic ticket within the last 12 months';
        return errors;
    }
    if (form.is21 !== true) {
        errors = 'You are not eligible for traffic school at this time, because you must be at least 18';
        return errors;
    }
    if (!form.lastName) errors += `${errors.length > 0 ? '; ' : ''}Your last name is required`;
    if (!form.firstName) errors += `${errors.length > 0 ? '; ' : ''}Your first name is required`;
    if (!radios.sex) errors += `${errors.length > 0 ? '; ' : ''}Your sex is required`;
    if (!form.address) errors += `${errors.length > 0 ? '; ' : ''}Your address is required`;
    if (!form.city) errors += `${errors.length > 0 ? '; ' : ''}Your city is required`;
    if (!form.state) errors += `${errors.length > 0 ? '; ' : ''}Your state is required`;
    if (!form.zip) errors += `${errors.length > 0 ? '; ' : ''}Your zip/postal code is required`;
    if (!form.address) errors += `${errors.length > 0 ? '; ' : ''}Your address is required`;
    if (!dob) {
        errors += `${errors.length > 0 ? '; ' : ''}Your date of birth is required`;
    } else if (!isValid(dob)) {
        errors += `${errors.length > 0 ? '; ' : ''}The date of birth is invalid`;
    } else if (!isPast(dob)) errors += `${errors.length > 0 ? '; ' : ''}The date of birth must be in the past`;
    if (!form.email) {
        errors += `${errors.length > 0 ? '; ' : ''}The email address is required`;
    } else if (!validateEmail(form.email)) {
        errors += `${errors.length > 0 ? '; ' : ''}The email address is invalid`;
    }
    if (!violationDate) {
        errors += `${errors.length > 0 ? '; ' : ''}The date of your ticket is required`;
    } else if (!isValid(violationDate)) {
        errors += `${errors.length > 0 ? '; ' : ''}The date of your ticket is invalid`;
    } else if (!isPast(violationDate)) errors += `${errors.length > 0 ? '; ' : ''}The date of your ticket must be in the past`;
    if (!form.license || !form.licenseState) errors += `${errors.length > 0 ? '; ' : ''}You must enter your driver license and state`;
    if (!form.classType) {
        errors += `${errors.length > 0 ? '; ' : ''}You must select a class type`;
    } else if (form.classType === 'inPerson' && !form.classLocation) errors += `${errors.length > 0 ? '; ' : ''}For an in-person class, you must select a class location`;
    if (!form.ethnicity && form.ethnicity !== '') errors += `${errors.length > 0 ? '; ' : ''}Please select your ethnic origin or indicate that you prefer not to respond`;
    if (!form.education && form.education !== '') errors += `${errors.length > 0 ? '; ' : ''}Please select your highest degree received or indicate that you prefer not to respond`;
    return errors;
}

export const getRockVyRequest = (form, balance, county, radios, dob, violationDate) => {
    return {
        optionTemplate: 'rockVy',
        optionType: balance.trafficSchoolType,
        firstName: form.firstName,
        middleInitial: form.middleInitial,
        lastName: form.lastName,
        dob: formatISO(dob, {representation: 'date'}),
        sex: radios.sex,
        address: form.address,
        city: form.city,
        state: form.state,
        zip: form.zip,
        phone: form.phone,
        email: form.email,
        license: form.license,
        licenseState: form.licenseState,
        county: county,
        violationDate: violationDate ? format(violationDate, 'P') : null,
        useSign: form.useSign,
        useWheelchair: form.useWheelchair,
        is21: form.is21,
        priorSupervision: (form.priorSupervision === 'Yes'),
        inPersonClass: (form.classType === 'inPerson'),
        saturdayMorningPreference: radios.saturdayMorning,
        saturdayAfternoonPreference: radios.saturdayAfternoon,
        weekdayEveningPreference: radios.weekdayEvening,
        classLocation: form.classLocation,
        ethnicity: form.ethnicity,
        otherEthnicity: form.ethnicity === 'O' ? form.otherEthnicity : null,
        education: form.education,
        otherEducation: form.education === 'O' ? form.otherEducation : null
    }
}
